import "core-js/modules/web.dom.iterable";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import Notifications from '~/mixins/Notifications';
import { ABTASTY_URL, SPEEDCURVE_URL } from '~/const/3rd';
export default {
  mixins: [Notifications],

  data() {
    return {
      tp: true,
      tcVars: {},
      container: "".concat(this.$store.state.sharedEnv.payload.web, "js/tc_MaisonsduMonde_3.js")
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    speedcurveConfig() {
      const luxConfig = {
        innerHTML: 'LUX=(function(){var a=("undefined"!==typeof(LUX)&&"undefined"!==typeof(LUX.gaMarks)?LUX.gaMarks:[]);var d=("undefined"!==typeof(LUX)&&"undefined"!==typeof(LUX.gaMeasures)?LUX.gaMeasures:[]);var h="LUX_start";var j=window.performance;var k=("undefined"!==typeof(LUX)&&LUX.ns?LUX.ns:(Date.now?Date.now():+(new Date())));if(j&&j.timing&&j.timing.navigationStart){k=j.timing.navigationStart}function e(){if(j){if(j.now){return j.now()}else{if(j.webkitNow){return j.now()}else{if(j.msNow){return j.now()}else{if(j.mozNow){return j.now()}}}}}var m=Date.now?Date.now():+(new Date());return m-k}function b(m){if(j){if(j.mark){return j.mark(m)}else{if(j.webkitMark){return j.webkitMark(m)}}}a.push({name:m,entryType:"mark",startTime:e(),duration:0});return}function l(o,s,m){if("undefined"===typeof(s)&&g(h)){s=h}if(j){if(j.measure){if(s){if(m){return j.measure(o,s,m)}else{return j.measure(o,s)}}else{return j.measure(o)}}else{if(j.webkitMeasure){return j.webkitMeasure(o,s,m)}}}var q=0,n=e();if(s){var r=g(s);if(r){q=r.startTime}else{if(j&&j.timing&&j.timing[s]){q=j.timing[s]-j.timing.navigationStart}else{return}}}if(m){var p=g(m);if(p){n=p.startTime}else{if(j&&j.timing&&j.timing[m]){n=j.timing[m]-j.timing.navigationStart}else{return}}}d.push({name:o,entryType:"measure",startTime:q,duration:(n-q)});return}function g(m){return c(m,f())}function c(p,o){for(i=o.length-1;i>=0;i--){var n=o[i];if(p===n.name){return n}}return undefined}function f(){if(j){if(j.getEntriesByType){return j.getEntriesByType("mark")}else{if(j.webkitGetEntriesByType){return j.webkitGetEntriesByType("mark")}}}return a}return{mark:b,measure:l,gaMarks:a,gaMeasures:d}})();LUX.ns=(Date.now?Date.now():+(new Date()));LUX.ac=[];LUX.cmd=function(a){LUX.ac.push(a)};LUX.samplerate = 10;'
      };
      return luxConfig;
    },

    tcVarsConfig() {
      return {
        innerHTML: "window.tc_vars = ".concat(JSON.stringify(this.tcVars), ";")
      };
    },

    tagCo() {
      if (!process.server || this.tp === false) {
        return false;
      }

      return {
        innerHTML: "\n        window.addEventListener(\"load\", function(){\n          var script = document.createElement('script');\n          var s = document.getElementsByTagName('script')[0];\n          script.type = 'text/javascript';\n          script.async = true;\n          script.src = '".concat(this.container, "?").concat(Math.floor(Date.now() / 1000), "';\n          s.parentNode.insertBefore(script, s);\n        }, { passive: true });")
      };
    },

    safariFix() {
      if (!process.server) {
        return false;
      }

      return {
        innerHTML: '!function(){var e=document,t=e.createElement("script");if(!("noModule"in t)&&"onbeforeload"in t){var n=!1;e.addEventListener("beforeload",function(e){if(e.target===t)n=!0;else if(!e.target.hasAttribute("nomodule")||!n)return;e.preventDefault()},!0),t.type="module",t.src=".",e.head.appendChild(t),t.remove()}}();'
      };
    }

  }),

  beforeCreate() {
    this.$root.$on('loginCheckoutContainer', () => {
      this.container = this.$store.state.sharedEnv.payload.tracking.checkout.container;
    });
  },

  created() {
    this.$root.$on('updated-tcvars', this.onUpdateTcVars);
  },

  mounted() {
    const nothirdparties = this.$cookies.get('nothirdparties');

    if (nothirdparties || 'nothirdparties' in this.$route.query) {
      this.tp = false;
    }

    window.history.scrollRestoration = 'auto';
    this.abTasty();
    window.addEventListener('load', this.onLoad, {
      passive: true
    });
    window.addEventListener('resize', this.onResize, {
      passive: true
    });
  },

  beforeDestroy() {
    this.$root.$off('updated-tcvars');
    this.$root.$off('loginCheckoutContainer');
  },

  methods: {
    onUpdateTcVars(tcVars) {
      this.tcVars = tcVars;

      if (process.client && Object.keys(this.tcVars).length) {
        if (this.$cookies.get('debugmdm')) {
          console.log('inject tcVars', _objectSpread({}, this.tcVars));
        }

        window.tc_vars = _objectSpread({}, this.tcVars);

        try {
          window.tC.container.reload();
          window.tC.event.reload();
          window.LUX.init();
        } catch (err) {
          if (this.$sentry) {
            this.$sentry.captureMessage(err);
          }
        }

        if (this.$cookies.get('debugmdm')) {
          console.log('after tagco container reload', _objectSpread({}, window.tc_vars));
        }
      }
    },

    abTasty() {
      if (this.tp === false) {
        return;
      }

      window.LUX.mark('before ABTasty');
      this.asyncScript(ABTASTY_URL).catch(err => {
        console.error('ABTASTY FAILED', err);
      });
    }

  },

  head() {
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [this.tcVarsConfig, this.tagCo, this.speedcurveConfig, this.safariFix, {
        src: SPEEDCURVE_URL,
        type: 'text/javascript',
        async: '',
        defer: ''
      }],
      meta: [{
        hid: 'robots',
        name: 'robots',
        content: 'noodp'
      }, {
        name: 'theme-color',
        content: '#3C3C3B'
      }],
      htmlAttrs: {
        lang: "".concat(this.locale.iso)
      }
    };
  }

};